__turbopack_context__.v({
  "content-card": "YeHexG_content-card",
  "content-card__content": "YeHexG_content-card__content",
  "content-card__content__copy": "YeHexG_content-card__content__copy",
  "content-card__content__label-with-icon": "YeHexG_content-card__content__label-with-icon",
  "content-card__content__label-with-icon__item": "YeHexG_content-card__content__label-with-icon__item",
  "content-card__content__label-with-icon__item-label": "YeHexG_content-card__content__label-with-icon__item-label",
  "content-card__content__tag-group": "YeHexG_content-card__content__tag-group",
  "content-card__heading": "YeHexG_content-card__heading",
  "content-card__heading__eyebrow": "YeHexG_content-card__heading__eyebrow",
  "content-card__heading__icon": "YeHexG_content-card__heading__icon",
  "content-card__heading__icon--gradient": "YeHexG_content-card__heading__icon--gradient",
  "content-card__heading__title": "YeHexG_content-card__heading__title",
  "content-card__image": "YeHexG_content-card__image",
  "content-card__image--desaturate": "YeHexG_content-card__image--desaturate",
  "content-card__separator": "YeHexG_content-card__separator",
});
